import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector, useShareFile } from '../../hooks'
import FilePermissions from './FilePermissions'
import { FileMS, selectFile } from '../../app/file'
import { selectApp } from '../../app/root'
import { Option } from './FilePermissions'
import { closeDialog, setDialog } from '../../app/dialog'
import {
  MappedFileTypes,
  StaticFileIconsConstant,
  msPermissionsOptions,
  valueToVerb,
} from '../../constants'
import { zoomSdkApi } from '../../app/zoomSdkQueries'

// ============================= Start V3 =============================
// Delete me to go to back to native collaboration
type FileShareDialogMS = {
  isNewDocument?: boolean
}
// ============================= End V3 =============================

// Handles both the new file and existing file dialogs
const FileShareDialogMS: FC<FileShareDialogMS> = ({
  isNewDocument = false,
}) => {
  const dispatch = useDispatch()
  const { screenName } = zoomSdkApi.endpoints.getUserContext.useQueryState(
    'getUserContext',
    {
      selectFromResult: (result) => ({
        screenName: result?.data?.screenName,
      }),
    }
  )
  const setShareFile = useShareFile()
  const { name, url, type, id, siteUrl, resourceUrl, driveId } = useAppSelector(
    selectFile
  ) as FileMS
  const app = useAppSelector(selectApp)!
  const [permission, setPermission] = useState<Option['value']>('editor')

  const Icon = StaticFileIconsConstant[app][type]
  const options = msPermissionsOptions

  const onClose = () => {
    zoomSdk.zmConfirmCollaborate({ startCollaborate: false }).catch(() => {
      //swallow
    })
    dispatch(closeDialog())
  }

  // ============================= Start V3 =============================
  // Uncomment me to go to back to native collaboration
  // const handleGrant = async () => {
  //   if (screenName) {
  //     const shareFileData = {
  //       drive: app,
  //       fileId: id,
  //       fileUrl: url,
  //       fileName: name,
  //       accessType: permission,
  //       fileType: MappedFileTypes[type],
  //       screenName,
  //       siteUrl,
  //       resourceUrl,
  //       driveId,
  //     }

  //     await zoomSdk
  //       .startCollaborate({
  //         messageText: `Upon joining, the email associated with your Microsoft account will be granted ${valueToVerb(permission)} access`,
  //       })
  //       .catch(() => {
  //         onClose()
  //       })

  //     setShareFile(shareFileData)
  //   }
  // }
  // ============================= End V3 =============================

  // ============================= Start V3 =============================
  // Delete me to go to back to native collaboration
  const handleGrant = async () => {
    if (screenName) {
      const shareFileData = {
        drive: app,
        fileId: id,
        fileUrl: url,
        fileName: name,
        accessType: permission,
        fileType: MappedFileTypes[type],
        screenName,
        siteUrl,
        resourceUrl,
        driveId,
      }

      await zoomSdk
        .zmSystemBrowserCollaboration({
          fileUrl: url,
          messageText: `Upon joining, the email associated with your Microsoft account will be granted ${valueToVerb(permission)} access`,
        })
        .then(() => {
          setShareFile(shareFileData)
          zoomSdk.sendAppToBackground() // we don't want to see the app
        })
        .catch((e) => {
          if (
            e?.message === 'The app is in collaborate mode.' ||
            e?.message === 'No Permission for this API.'
          ) {
            dispatch(setDialog({ type: 'collaborationInProgress' }))
          } else {
            dispatch(closeDialog())
          }
        })
    }
  }

  return isNewDocument ? (
    <FilePermissions
      options={options}
      onChange={setPermission}
      handleGrant={handleGrant}
      onClose={onClose}
      fileName={name}
      icon={Icon}
      app={app}
    />
  ) : (
    <FilePermissions
      options={options}
      onChange={setPermission}
      handleGrant={handleGrant}
      onClose={onClose}
      fileName={name}
      fileUrl={url}
      icon={Icon}
      app={app}
    />
  )
  // ============================= End V3 =============================

  // ============================= Start V3 =============================
  // Uncomment me to go to back to native collaboration
  // return (
  //   <FilePermissions
  //     options={options}
  //     onChange={setPermission}
  //     handleGrant={handleGrant}
  //     onClose={onClose}
  //     fileName={name}
  //     fileUrl={url}
  //     icon={Icon}
  //     app={app}
  //   />
  // )
  // ============================= End V3 =============================
}

export default FileShareDialogMS
